import { jsxs as c, jsx as o, Fragment as nt } from "react/jsx-runtime";
import { useState as K, useCallback as R, useEffect as D, useRef as G, forwardRef as d, useId as I, useMemo as lt } from "react";
import { createPortal as st } from "react-dom";
const at = "heurix.theme";
function dt() {
  var t;
  if (typeof window > "u") return "dark";
  try {
    const e = window.localStorage.getItem(at);
    if (e === "dark" || e === "light") return e;
  } catch {
  }
  return (t = window.matchMedia) != null && t.call(window, "(prefers-color-scheme: light)").matches ? "light" : "dark";
}
function F(t) {
  document.documentElement.setAttribute("data-theme", t);
}
function _t() {
  const [t, e] = K(() => {
    const a = dt();
    return typeof document < "u" && F(a), a;
  }), n = R((a) => {
    e(a), F(a);
    try {
      window.localStorage.setItem(at, a);
    } catch {
    }
  }, []), s = R(() => {
    n(t === "dark" ? "light" : "dark");
  }, [t, n]);
  return D(() => {
    F(t);
  }, [t]), { theme: t, setTheme: n, toggle: s };
}
function zn(t = 1400) {
  const [e, n] = K("idle"), s = G(null), a = R(
    async (r) => {
      try {
        await navigator.clipboard.writeText(r), n("copied");
      } catch {
        n("error");
      }
      s.current && window.clearTimeout(s.current), s.current = window.setTimeout(() => n("idle"), t);
    },
    [t]
  );
  return { state: e, copy: a };
}
function i(...t) {
  return t.filter((e) => typeof e == "string" && e.length > 0).join(" ");
}
const mt = "_root_2aqvs_1", ut = "_sm_2aqvs_25", ht = "_md_2aqvs_26", pt = "_lg_2aqvs_27", gt = "_primary_2aqvs_29", Nt = "_ghost_2aqvs_40", ft = "_secondary_2aqvs_50", bt = "_danger_2aqvs_60", vt = "_loading_2aqvs_71", yt = "_spinner_2aqvs_79", M = {
  root: mt,
  sm: ut,
  md: ht,
  lg: pt,
  primary: gt,
  ghost: Nt,
  secondary: ft,
  danger: bt,
  loading: vt,
  spinner: yt,
  "ds-button-spin": "_ds-button-spin_2aqvs_1"
}, $t = { sm: 12, md: 14, lg: 16 };
function kt({ size: t }) {
  const e = $t[t];
  return /* @__PURE__ */ o("span", { className: M.spinner, style: { width: e, height: e }, "aria-hidden": "true" });
}
function wt({
  as: t,
  variant: e = "secondary",
  size: n = "md",
  loading: s = !1,
  className: a,
  children: r,
  ...l
}, m) {
  const u = t ?? "button";
  return /* @__PURE__ */ c(
    u,
    {
      ref: m,
      ...u === "button" ? { type: l.type ?? "button" } : {},
      className: i(M.root, M[n], M[e], s && M.loading, a),
      "aria-busy": s || void 0,
      ...l,
      children: [
        s && /* @__PURE__ */ o(kt, { size: n }),
        r
      ]
    }
  );
}
const Sn = d(wt), xt = "_root_1rhjx_1", jt = "_sm_1rhjx_28", It = "_md_1rhjx_29", zt = "_lg_1rhjx_30", St = "_danger_1rhjx_31", H = {
  root: xt,
  sm: jt,
  md: It,
  lg: zt,
  danger: St
}, rt = d(
  ({ size: t = "md", tone: e = "neutral", className: n, type: s = "button", ...a }, r) => /* @__PURE__ */ o(
    "button",
    {
      ref: r,
      type: s,
      className: i(H.root, H[t], e === "danger" && H.danger, n),
      ...a
    }
  )
);
rt.displayName = "IconButton";
const Bt = "_root_1tsbm_1", Tt = "_active_1tsbm_25", Ct = "_ai_1tsbm_36", Mt = "_commit_1tsbm_55", E = {
  root: Bt,
  active: Tt,
  ai: Ct,
  commit: Mt
}, Lt = d(
  ({
    active: t,
    aiSuggested: e,
    pulseOnClick: n = !0,
    className: s,
    onClick: a,
    children: r,
    type: l = "button",
    ...m
  }, u) => {
    const [p, h] = K(!1);
    return D(() => {
      if (p) {
        const g = window.setTimeout(() => h(!1), 340);
        return () => window.clearTimeout(g);
      }
    }, [p]), /* @__PURE__ */ o(
      "button",
      {
        ref: u,
        type: l,
        "aria-pressed": t,
        "data-ai": e ? "true" : void 0,
        className: i(E.root, t && E.active, e && E.ai, p && E.commit, s),
        onClick: (g) => {
          n && h(!0), a == null || a(g);
        },
        ...m,
        children: r
      }
    );
  }
);
Lt.displayName = "Pill";
const Et = "_conf_1unmg_1", qt = "_dot_1unmg_15", At = "_dotOn_1unmg_21", Rt = "_sg_1unmg_23", Dt = "_high_1unmg_37", Ft = "_medium_1unmg_42", Ht = "_low_1unmg_47", Pt = "_heuristic_1unmg_52", L = {
  conf: Et,
  dot: qt,
  dotOn: At,
  sg: Rt,
  high: Dt,
  medium: Ft,
  low: Ht,
  heuristic: Pt
}, U = { low: 1, medium: 2, high: 3 }, Wt = d(
  ({ level: t, label: e, className: n, ...s }, a) => /* @__PURE__ */ c("span", { ref: a, className: i(L.conf, n), ...s, children: [
    [0, 1, 2].map((r) => /* @__PURE__ */ o(
      "span",
      {
        className: i(L.dot, r < U[t] && L.dotOn),
        "data-on": r < U[t] ? "true" : "false"
      },
      r
    )),
    e
  ] })
);
Wt.displayName = "ConfidenceChip";
const Kt = d(
  ({ priority: t, className: e, ...n }, s) => /* @__PURE__ */ o("span", { ref: s, className: i(L.sg, L[t], e), ...n })
);
Kt.displayName = "SuggestionChip";
const Gt = "_root_1pbmf_1", Ot = "_dot_1pbmf_14", Y = {
  root: Gt,
  dot: Ot
}, Ut = d(
  ({ value: t, withDot: e, className: n, ...s }, a) => /* @__PURE__ */ c("span", { ref: a, className: i(Y.root, n), ...s, children: [
    e && /* @__PURE__ */ o("span", { className: Y.dot, "aria-hidden": "true" }),
    t
  ] })
);
Ut.displayName = "CountBadge";
const Yt = "_root_evml0_1", Zt = "_dot_evml0_16", Z = {
  root: Yt,
  dot: Zt
}, ct = d(
  ({ children: t = "AI", className: e, ...n }, s) => /* @__PURE__ */ c("span", { ref: s, className: i(Z.root, e), ...n, children: [
    /* @__PURE__ */ o("span", { className: Z.dot, "aria-hidden": "true" }),
    t
  ] })
);
ct.displayName = "AIBadge";
const Jt = "_root_1ddaj_1", Qt = "_onAccent_1ddaj_16", J = {
  root: Jt,
  onAccent: Qt
}, Xt = d(
  ({ onAccent: t, className: e, ...n }, s) => /* @__PURE__ */ o("kbd", { ref: s, className: i(J.root, t && J.onAccent, e), ...n })
);
Xt.displayName = "Kbd";
const Vt = "_field_haejm_1", te = "_label_haejm_7", ee = "_input_haejm_14", oe = "_invalid_haejm_35", ne = "_hint_haejm_39", se = "_error_haejm_40", j = {
  field: Vt,
  label: te,
  input: ee,
  invalid: oe,
  hint: ne,
  error: se
}, ae = d(
  ({ label: t, hint: e, error: n, id: s, className: a, ...r }, l) => {
    const m = I(), u = s ?? m, p = e ? `${u}-hint` : void 0, h = n ? `${u}-err` : void 0, g = [p, h].filter(Boolean).join(" ") || void 0;
    return /* @__PURE__ */ c("div", { className: i(j.field, a), children: [
      t && /* @__PURE__ */ o("label", { htmlFor: u, className: j.label, children: t }),
      /* @__PURE__ */ o(
        "input",
        {
          ref: l,
          id: u,
          "aria-invalid": !!n || void 0,
          "aria-describedby": g,
          className: i(j.input, n && j.invalid),
          ...r
        }
      ),
      e && !n && /* @__PURE__ */ o("span", { id: p, className: j.hint, children: e }),
      n && /* @__PURE__ */ o("span", { id: h, className: j.error, role: "alert", children: n })
    ] });
  }
);
ae.displayName = "Input";
const re = "_field_1bagn_1", ce = "_label_1bagn_7", ie = "_textarea_1bagn_14", P = {
  field: re,
  label: ce,
  textarea: ie
}, le = d(
  ({ label: t, id: e, className: n, ...s }, a) => {
    const r = I(), l = e ?? r;
    return /* @__PURE__ */ c("div", { className: i(P.field, n), children: [
      t && /* @__PURE__ */ o("label", { htmlFor: l, className: P.label, children: t }),
      /* @__PURE__ */ o("textarea", { ref: a, id: l, className: P.textarea, ...s })
    ] });
  }
);
le.displayName = "Textarea";
const de = "_root_nz213_1", _e = {
  root: de
}, me = d(
  ({ className: t, ...e }, n) => /* @__PURE__ */ o("span", { ref: n, className: i(_e.root, t), ...e })
);
me.displayName = "Eyebrow";
const ue = "_root_1sndj_1", he = "_lg_1sndj_10", pe = "_xl_1sndj_11", ge = "_xxl_1sndj_12", Q = {
  root: ue,
  lg: he,
  xl: pe,
  xxl: ge
}, Ne = d(
  ({ size: t = "xl", className: e, ...n }, s) => /* @__PURE__ */ o("span", { ref: s, className: i(Q.root, Q[t], e), ...n })
);
Ne.displayName = "Numeral";
const fe = "_root_v9f7p_1", be = "_sm_v9f7p_22", ve = "_md_v9f7p_23", ye = "_lg_v9f7p_24", X = {
  root: fe,
  sm: be,
  md: ve,
  lg: ye
}, it = d(
  ({ size: t = "md", label: e = "Heurix", glyph: n = "h", className: s, ...a }, r) => /* @__PURE__ */ o(
    "span",
    {
      ref: r,
      role: "img",
      "aria-label": e,
      className: i(X.root, X[t], s),
      ...a,
      children: /* @__PURE__ */ o("span", { "aria-hidden": "true", children: n })
    }
  )
);
it.displayName = "BrandMark";
const $e = "_root_1bgaf_1", ke = {
  root: $e
}, we = d(
  ({ label: t, className: e, children: n, ...s }, a) => /* @__PURE__ */ o(
    "div",
    {
      ref: a,
      role: "group",
      "aria-label": t,
      className: i(ke.root, e),
      ...s,
      children: n
    }
  )
);
we.displayName = "PillGroup";
const xe = "_field_2714v_1", je = "_label_2714v_7", Ie = "_wrap_2714v_14", ze = "_icon_2714v_18", Se = "_valid_2714v_28", Be = "_input_2714v_31", Te = "_invalid_2714v_52", Ce = "_error_2714v_56", b = {
  field: xe,
  label: je,
  wrap: Ie,
  icon: ze,
  valid: Se,
  input: Be,
  invalid: Te,
  error: Ce
}, Me = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    children: [
      /* @__PURE__ */ o("path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" }),
      /* @__PURE__ */ o("path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" })
    ]
  }
);
function Le(t) {
  if (typeof t != "string" || t.length < 10) return !1;
  try {
    const e = new URL(t);
    return e.protocol === "http:" || e.protocol === "https:";
  } catch {
    return !1;
  }
}
const Ee = d(
  ({ label: t, error: e, id: n, className: s, placeholder: a = "https://staging.example.com/checkout", value: r, defaultValue: l, ...m }, u) => {
    const p = I(), h = n ?? p, g = e ? `${h}-err` : void 0, N = lt(() => Le(r ?? l), [r, l]);
    return /* @__PURE__ */ c("div", { className: i(b.field, s), children: [
      t && /* @__PURE__ */ o("label", { htmlFor: h, className: b.label, children: t }),
      /* @__PURE__ */ c("div", { className: b.wrap, children: [
        /* @__PURE__ */ o("span", { className: i(b.icon, N && b.valid), children: /* @__PURE__ */ o(Me, {}) }),
        /* @__PURE__ */ o(
          "input",
          {
            ref: u,
            id: h,
            type: "url",
            inputMode: "url",
            autoComplete: "url",
            spellCheck: !1,
            placeholder: a,
            value: r,
            defaultValue: l,
            "aria-invalid": !!e || void 0,
            "aria-describedby": g,
            className: i(b.input, e && b.invalid),
            ...m
          }
        )
      ] }),
      e && /* @__PURE__ */ o("span", { id: g, className: b.error, role: "alert", children: e })
    ] });
  }
);
Ee.displayName = "UrlInput";
const qe = "_input_16dxz_1", Ae = {
  input: qe
}, Re = d(
  ({ ariaLabel: t, id: e, className: n, placeholder: s = "Sem título", ...a }, r) => {
    const l = I();
    return /* @__PURE__ */ o(
      "input",
      {
        ref: r,
        id: e ?? l,
        "aria-label": t,
        type: "text",
        spellCheck: !1,
        placeholder: s,
        className: i(Ae.input, n),
        ...a
      }
    );
  }
);
Re.displayName = "TitleInput";
const De = "_iconHidden_7jo6r_1", V = {
  iconHidden: De
}, Fe = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ o("circle", { cx: "12", cy: "12", r: "4" }),
      /* @__PURE__ */ o("path", { d: "M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" })
    ]
  }
), He = () => /* @__PURE__ */ o(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: /* @__PURE__ */ o("path", { d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" })
  }
), Pe = d(
  ({ ariaLabel: t = "Alternar tema", size: e = "md", ...n }, s) => {
    const { theme: a, toggle: r } = _t();
    return /* @__PURE__ */ c(
      rt,
      {
        ref: s,
        "aria-label": t,
        "aria-pressed": a === "light",
        size: e,
        onClick: r,
        ...n,
        children: [
          /* @__PURE__ */ o("span", { className: a === "light" ? V.iconHidden : void 0, children: /* @__PURE__ */ o(Fe, {}) }),
          /* @__PURE__ */ o("span", { className: a === "dark" ? V.iconHidden : void 0, children: /* @__PURE__ */ o(He, {}) })
        ]
      }
    );
  }
);
Pe.displayName = "ThemeToggle";
const We = "_root_oekix_1", Ke = "_paused_oekix_21", tt = {
  root: We,
  paused: Ke
}, Ge = d(
  ({ label: t = "Carregando", paused: e, className: n, ...s }, a) => /* @__PURE__ */ o(
    "div",
    {
      ref: a,
      role: "progressbar",
      "aria-label": t,
      "aria-busy": !e,
      className: i(tt.root, e && tt.paused, n),
      ...s
    }
  )
);
Ge.displayName = "ScanBar";
const Oe = "_root_1csrk_4", Ue = "_sm_1csrk_11", Ye = "_md_1csrk_12", Ze = "_lg_1csrk_13", et = {
  root: Oe,
  "ds-spin": "_ds-spin_1csrk_1",
  sm: Ue,
  md: Ye,
  lg: Ze
}, Je = d(
  ({ size: t = "md", label: e = "Carregando", className: n, ...s }, a) => /* @__PURE__ */ o(
    "span",
    {
      ref: a,
      role: "status",
      "aria-label": e,
      className: i(et.root, et[t], n),
      ...s
    }
  )
);
Je.displayName = "Spinner";
const Qe = "_root_157bz_1", Xe = "_line_157bz_13", W = {
  root: Qe,
  line: Xe
}, Ve = d(
  ({ children: t = "Fim da lista", className: e, ...n }, s) => /* @__PURE__ */ c("div", { ref: s, className: i(W.root, e), ...n, children: [
    /* @__PURE__ */ o("span", { className: W.line, "aria-hidden": "true" }),
    t,
    /* @__PURE__ */ o("span", { className: W.line, "aria-hidden": "true" })
  ] })
);
Ve.displayName = "Sentinel";
const to = "_root_1gpa3_1", eo = "_brand_1gpa3_14", oo = "_title_1gpa3_15", no = "_divider_1gpa3_16", so = "_subtitle_1gpa3_17", ao = "_right_1gpa3_18", ro = "_meta_1gpa3_24", co = "_metaDot_1gpa3_32", v = {
  root: to,
  brand: eo,
  title: oo,
  divider: no,
  subtitle: so,
  right: ao,
  meta: ro,
  metaDot: co
}, io = d(
  ({
    title: t = "Heurix",
    subtitle: e,
    meta: n,
    right: s,
    showLiveDot: a = !0,
    showBrand: r = !0,
    className: l,
    ...m
  }, u) => /* @__PURE__ */ c("header", { ref: u, className: i(v.root, l), ...m, children: [
    /* @__PURE__ */ c("div", { className: v.brand, children: [
      r && /* @__PURE__ */ o(it, { size: "md" }),
      t && /* @__PURE__ */ o("strong", { className: v.title, children: t }),
      e && /* @__PURE__ */ c(nt, { children: [
        /* @__PURE__ */ o("span", { className: v.divider, children: "/" }),
        /* @__PURE__ */ o("span", { className: v.subtitle, children: e })
      ] })
    ] }),
    /* @__PURE__ */ c("div", { className: v.right, children: [
      n && /* @__PURE__ */ c("span", { className: v.meta, children: [
        a && /* @__PURE__ */ o("span", { className: v.metaDot, "aria-hidden": "true" }),
        n
      ] }),
      s
    ] })
  ] })
);
io.displayName = "Topbar";
const lo = "_root_eozrv_1", _o = "_head_eozrv_24", mo = "_url_eozrv_30", uo = "_title_eozrv_39", ho = "_meta_eozrv_50", z = {
  root: lo,
  head: _o,
  url: mo,
  title: uo,
  meta: ho
}, po = d(
  ({ url: t, title: e, meta: n, trailing: s, className: a, type: r = "button", ...l }, m) => /* @__PURE__ */ c("button", { ref: m, type: r, className: i(z.root, a), ...l, children: [
    /* @__PURE__ */ c("div", { className: z.head, children: [
      /* @__PURE__ */ o("span", { className: z.url, title: t, children: t }),
      s
    ] }),
    /* @__PURE__ */ o("div", { className: z.title, children: e }),
    n && /* @__PURE__ */ o("div", { className: z.meta, children: n })
  ] })
);
po.displayName = "ProjectCard";
const go = "_root_160u8_1", No = "_meta_160u8_20", fo = "_url_160u8_21", bo = "_title_160u8_29", vo = "_score_160u8_37", S = {
  root: go,
  meta: No,
  url: fo,
  title: bo,
  score: vo
}, yo = d(
  ({ url: t, title: e, score: n, status: s, trailing: a, className: r, type: l = "button", ...m }, u) => /* @__PURE__ */ c("button", { ref: u, type: l, className: i(S.root, r), ...m, children: [
    /* @__PURE__ */ c("div", { className: S.meta, children: [
      /* @__PURE__ */ o("span", { className: S.url, title: t, children: t }),
      /* @__PURE__ */ o("span", { className: S.title, children: e })
    ] }),
    s,
    n && /* @__PURE__ */ o("span", { className: S.score, children: n }),
    a
  ] })
);
yo.displayName = "EvalRow";
const $o = "_root_yudpw_1", ko = "_head_yudpw_27", wo = "_title_yudpw_32", xo = "_body_yudpw_33", q = {
  root: $o,
  head: ko,
  title: wo,
  body: xo
}, jo = d(
  ({ title: t, meta: e, className: n, children: s, ...a }, r) => /* @__PURE__ */ c("section", { ref: r, className: i(q.root, n), ...a, children: [
    /* @__PURE__ */ c("header", { className: q.head, children: [
      /* @__PURE__ */ o(ct, {}),
      t && /* @__PURE__ */ o("span", { className: q.title, children: t }),
      e && /* @__PURE__ */ o("span", { style: { marginLeft: "auto" }, children: e })
    ] }),
    /* @__PURE__ */ o("div", { className: q.body, children: s })
  ] })
);
jo.displayName = "AIBlock";
const Io = "_root_13ipj_1", zo = "_head_13ipj_31", So = "_title_13ipj_37", Bo = "_body_13ipj_42", To = "_foot_13ipj_47", B = {
  root: Io,
  head: zo,
  title: So,
  body: Bo,
  foot: To
}, Co = d(
  ({ title: t, chips: e, footer: n, className: s, children: a, ...r }, l) => /* @__PURE__ */ c("article", { ref: l, className: i(B.root, s), ...r, children: [
    /* @__PURE__ */ c("header", { className: B.head, children: [
      e,
      /* @__PURE__ */ o("span", { className: B.title, children: t })
    ] }),
    /* @__PURE__ */ o("div", { className: B.body, children: a }),
    n && /* @__PURE__ */ o("footer", { className: B.foot, children: n })
  ] })
);
Co.displayName = "SuggestionCard";
const Mo = "_root_2urio_1", Lo = "_head_2urio_27", Eo = "_title_2urio_28", qo = "_meta_2urio_29", Ao = "_right_2urio_36", T = {
  root: Mo,
  head: Lo,
  title: Eo,
  meta: qo,
  right: Ao
}, Ro = d(
  ({ title: t, meta: e, trailing: n, className: s, ...a }, r) => /* @__PURE__ */ c("header", { ref: r, className: i(T.root, s), ...a, children: [
    /* @__PURE__ */ c("div", { className: T.head, children: [
      /* @__PURE__ */ o("span", { className: T.title, children: t }),
      e && /* @__PURE__ */ o("span", { className: T.meta, children: e })
    ] }),
    n && /* @__PURE__ */ o("div", { className: T.right, children: n })
  ] })
);
Ro.displayName = "SuggestionRunHeader";
const Do = "_tile_1g3z1_1", Fo = "_label_1g3z1_8", Ho = "_value_1g3z1_16", Po = "_unit_1g3z1_25", Wo = "_helper_1g3z1_33", Ko = "_grid_1g3z1_39", w = {
  tile: Do,
  label: Fo,
  value: Ho,
  unit: Po,
  helper: Wo,
  grid: Ko,
  "cols-3": "_cols-3_1g3z1_51",
  "cols-2": "_cols-2_1g3z1_52"
}, Go = d(
  ({ label: t, value: e, unit: n, helper: s, className: a, ...r }, l) => /* @__PURE__ */ c("div", { ref: l, className: i(w.tile, a), ...r, children: [
    /* @__PURE__ */ o("span", { className: w.label, children: t }),
    /* @__PURE__ */ c("span", { className: w.value, children: [
      e,
      n && /* @__PURE__ */ o("span", { className: w.unit, children: n })
    ] }),
    s && /* @__PURE__ */ o("span", { className: w.helper, children: s })
  ] })
);
Go.displayName = "StatsTile";
const Oo = d(
  ({ cols: t = 3, className: e, ...n }, s) => /* @__PURE__ */ o("div", { ref: s, className: i(w.grid, w[`cols-${t}`], e), ...n })
);
Oo.displayName = "StatsGrid";
const Uo = "_root_mau60_1", Yo = "_icon_mau60_8", Zo = "_title_mau60_20", Jo = "_message_mau60_26", Qo = "_actions_mau60_32", C = {
  root: Uo,
  icon: Yo,
  title: Zo,
  message: Jo,
  actions: Qo
}, Xo = d(
  ({ icon: t, title: e, message: n, actions: s, className: a, ...r }, l) => /* @__PURE__ */ c("div", { ref: l, className: i(C.root, a), ...r, children: [
    t && /* @__PURE__ */ o("span", { className: C.icon, "aria-hidden": "true", children: t }),
    /* @__PURE__ */ o("h4", { className: C.title, children: e }),
    n && /* @__PURE__ */ o("p", { className: C.message, children: n }),
    s && /* @__PURE__ */ o("div", { className: C.actions, children: s })
  ] })
);
Xo.displayName = "EmptyState";
const Vo = "_root_84mjn_1", tn = "_error_84mjn_16", en = "_icon_84mjn_21", on = "_message_84mjn_31", A = {
  root: Vo,
  error: tn,
  icon: en,
  message: on
}, nn = () => /* @__PURE__ */ o(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    children: /* @__PURE__ */ o("path", { d: "M20 6 9 17l-5-5" })
  }
), sn = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    children: [
      /* @__PURE__ */ o("circle", { cx: "12", cy: "12", r: "10" }),
      /* @__PURE__ */ o("path", { d: "M12 8v4M12 16h.01" })
    ]
  }
), an = d(
  ({ tone: t = "default", message: e, icon: n, className: s, children: a, ...r }, l) => {
    const m = t === "error" ? /* @__PURE__ */ o(sn, {}) : /* @__PURE__ */ o(nn, {}), u = n !== null;
    return /* @__PURE__ */ c(
      "div",
      {
        ref: l,
        role: t === "error" ? "alert" : "status",
        "aria-live": t === "error" ? "assertive" : "polite",
        className: i(A.root, t === "error" && A.error, s),
        ...r,
        children: [
          u && /* @__PURE__ */ o("span", { className: A.icon, children: n ?? m }),
          /* @__PURE__ */ o("span", { className: A.message, children: e ?? a })
        ]
      }
    );
  }
);
an.displayName = "Toast";
const rn = "_backdrop_1yzkd_1", cn = "_dialog_1yzkd_11", ln = "_head_1yzkd_23", dn = "_title_1yzkd_30", _n = "_close_1yzkd_35", mn = "_body_1yzkd_45", un = "_foot_1yzkd_46", $ = {
  backdrop: rn,
  dialog: cn,
  head: ln,
  title: dn,
  close: _n,
  body: mn,
  foot: un
}, ot = [
  "a[href]",
  "button:not([disabled])",
  "textarea:not([disabled])",
  "input:not([disabled])",
  "select:not([disabled])",
  '[tabindex]:not([tabindex="-1"])'
].join(","), hn = () => /* @__PURE__ */ o(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    children: /* @__PURE__ */ o("path", { d: "M18 6 6 18M6 6l12 12" })
  }
), pn = d(
  ({
    open: t,
    onClose: e,
    title: n,
    footer: s,
    closeOnOverlay: a = !0,
    closeOnEsc: r = !0,
    className: l,
    children: m,
    ...u
  }, p) => {
    const h = G(null), g = I(), N = R(
      (_) => {
        if (t && (_.key === "Escape" && r && (_.preventDefault(), e()), _.key === "Tab" && h.current)) {
          const f = h.current.querySelectorAll(ot);
          if (f.length === 0) return;
          const y = f[0], x = f[f.length - 1];
          if (!y || !x) return;
          _.shiftKey && document.activeElement === y ? (_.preventDefault(), x.focus()) : !_.shiftKey && document.activeElement === x && (_.preventDefault(), y.focus());
        }
      },
      [t, e, r]
    );
    return D(() => {
      var x;
      if (!t) return;
      const _ = document.activeElement, f = h.current, y = f == null ? void 0 : f.querySelectorAll(ot);
      return (x = y == null ? void 0 : y[0]) == null || x.focus(), document.addEventListener("keydown", N), () => {
        var O;
        document.removeEventListener("keydown", N), (O = _ == null ? void 0 : _.focus) == null || O.call(_);
      };
    }, [t, N]), !t || typeof document > "u" ? null : st(
      /* @__PURE__ */ o(
        "div",
        {
          className: $.backdrop,
          onMouseDown: (_) => {
            a && _.target === _.currentTarget && e();
          },
          children: /* @__PURE__ */ c(
            "div",
            {
              ref: (_) => {
                h.current = _, typeof p == "function" ? p(_) : p && (p.current = _);
              },
              role: "dialog",
              "aria-modal": "true",
              "aria-labelledby": n ? g : void 0,
              className: i($.dialog, l),
              ...u,
              children: [
                n && /* @__PURE__ */ c("header", { className: $.head, children: [
                  /* @__PURE__ */ o("h2", { id: g, className: $.title, children: n }),
                  /* @__PURE__ */ o(
                    "button",
                    {
                      type: "button",
                      className: $.close,
                      onClick: e,
                      "aria-label": "Fechar",
                      children: /* @__PURE__ */ o(hn, {})
                    }
                  )
                ] }),
                /* @__PURE__ */ o("div", { className: $.body, children: m }),
                s && /* @__PURE__ */ o("footer", { className: $.foot, children: s })
              ]
            }
          )
        }
      ),
      document.body
    );
  }
);
pn.displayName = "Modal";
const gn = "_backdrop_1mnzi_1", Nn = "_panel_1mnzi_8", fn = "_head_1mnzi_23", bn = "_title_1mnzi_31", vn = "_close_1mnzi_32", yn = "_body_1mnzi_42", $n = "_foot_1mnzi_43", k = {
  backdrop: gn,
  panel: Nn,
  head: fn,
  title: bn,
  close: vn,
  body: yn,
  foot: $n
}, kn = () => /* @__PURE__ */ o(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    children: /* @__PURE__ */ o("path", { d: "M18 6 6 18M6 6l12 12" })
  }
), wn = d(
  ({ open: t, onClose: e, title: n, footer: s, className: a, children: r, ...l }, m) => {
    const u = G(null), p = I();
    return D(() => {
      var N;
      if (!t) return;
      const h = (_) => {
        _.key === "Escape" && e();
      };
      document.addEventListener("keydown", h);
      const g = document.activeElement;
      return (N = u.current) == null || N.focus(), () => {
        var _;
        document.removeEventListener("keydown", h), (_ = g == null ? void 0 : g.focus) == null || _.call(g);
      };
    }, [t, e]), !t || typeof document > "u" ? null : st(
      /* @__PURE__ */ c(nt, { children: [
        /* @__PURE__ */ o("div", { className: k.backdrop, onClick: e, "aria-hidden": "true" }),
        /* @__PURE__ */ c(
          "aside",
          {
            ref: (h) => {
              u.current = h, typeof m == "function" ? m(h) : m && (m.current = h);
            },
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": n ? p : void 0,
            tabIndex: -1,
            className: i(k.panel, a),
            ...l,
            children: [
              n && /* @__PURE__ */ c("header", { className: k.head, children: [
                /* @__PURE__ */ o("h2", { id: p, className: k.title, children: n }),
                /* @__PURE__ */ o("button", { type: "button", className: k.close, onClick: e, "aria-label": "Fechar", children: /* @__PURE__ */ o(kn, {}) })
              ] }),
              /* @__PURE__ */ o("div", { className: k.body, children: r }),
              s && /* @__PURE__ */ o("footer", { className: k.foot, children: s })
            ]
          }
        )
      ] }),
      document.body
    );
  }
);
wn.displayName = "Drawer";
export {
  ct as AIBadge,
  jo as AIBlock,
  it as BrandMark,
  Sn as Button,
  Wt as ConfidenceChip,
  Ut as CountBadge,
  wn as Drawer,
  Xo as EmptyState,
  yo as EvalRow,
  me as Eyebrow,
  rt as IconButton,
  ae as Input,
  Xt as Kbd,
  pn as Modal,
  Ne as Numeral,
  Lt as Pill,
  we as PillGroup,
  po as ProjectCard,
  Ge as ScanBar,
  Ve as Sentinel,
  Je as Spinner,
  Oo as StatsGrid,
  Go as StatsTile,
  Co as SuggestionCard,
  Kt as SuggestionChip,
  Ro as SuggestionRunHeader,
  le as Textarea,
  Pe as ThemeToggle,
  Re as TitleInput,
  an as Toast,
  io as Topbar,
  Ee as UrlInput,
  i as cx,
  zn as useCopyToClipboard,
  _t as useTheme
};
//# sourceMappingURL=index.js.map
